import createAction from '@wix/communities-blog-client-common/dist/src/services/create-action';

export const CLEAR_MEMBERS = 'member/CLEAR';

export default createAction(CLEAR_MEMBERS);
